import axiosIns from '@/libs/axios'

const POS_CONFIG_KEYS = {
  1: [
    'nestpay_client_id',
    'nestpay_client_api_name',
    'nestpay_classic_api_password',
    'nestpay_3d_store_key',
    'nestpay_api_url',
    'nestpay_3d_url',
  ],
  2: [
    'gvp_terminal_id',
    'gvp_merchant_id',
    'gvp_user_name',
    'gvp_provaut_password',
    'gvp_3d_store_key',
    'gvp_api_url',
    'gvp_3d_url',
  ],
  3: [
    'get724_merchant_id',
    'get724_user_name',
    'get724_provaut_password',
    'get724_3d_store_key',
    'get724_api_url',
    'get724_3d_url',
  ],
  4: [
    'posnet_client_id',
    'posnet_terminal_id',
    'posnet_merchant_id',
    'posnet_encKey',
    'posnet_api_url',
    'posnet_3d_url',
  ],
  5: [
    'payfor_merchant_id',
    'payfor_merchant_pass',
    'payfor_usercode',
    'payfor_userpass',
    'payfor_api_url',
    'payfor_3d_url',
  ],
  6: [
    'akbank_merchant_safe_id',
    'akbank_terminal_safe_id',
    'akbank_secret_key',
    'akbank_3d_url',
    'akbank_api_url',
  ],
}

const hasConfigValue = value => value !== null && value !== undefined && value !== ''

const parseConfig = raw => {
  let config = raw
  if (typeof config === 'string') {
    try {
      config = JSON.parse(config)
      if (typeof config === 'string') config = JSON.parse(config)
    } catch (e) {
      return {}
    }
  }
  if (!config || typeof config !== 'object' || Array.isArray(config)) return {}
  return { ...config }
}

const emptyConfigForPosType = idPosTypes => {
  const keys = POS_CONFIG_KEYS[Number(idPosTypes)] || []
  return keys.reduce((acc, key) => {
    acc[key] = null
    return acc
  }, {})
}

const pickConfigForPosType = (raw, idPosTypes) => {
  const source = parseConfig(raw)
  const keys = POS_CONFIG_KEYS[Number(idPosTypes)]
  if (!keys) return {}
  return keys.reduce((acc, key) => {
    acc[key] = hasConfigValue(source[key]) ? source[key] : null
    return acc
  }, {})
}

const compactConfig = config => {
  const compact = {}
  Object.keys(config || {}).forEach(key => {
    if (hasConfigValue(config[key])) compact[key] = config[key]
  })
  return compact
}

const defaultPosConfig = () => ({
  default: 0,
  status: 0,
  pay3d: 1,
  config: {},
  installments: [
    {
      text: 'Tek Çekim',
      installment: 0,
      rate: 0,
    },
  ],
  id_pos_types: null,
  id_banks: null,
})

export default {
  namespaced: true,
  state: {
    pos_types: [],
    pos_configs: [],
    pos_configsCount: 0,
    pos_config: defaultPosConfig(),
    pos_config_pay3d: 1,
    pos_installments: [],
    pos_installmentsv2: {
      header: [],
      body: [],
    },
    pos_configSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getPosTypes(state) {
      return state.pos_types
    },
    getPos_configs(state) {
      return state.pos_configs
    },
    getPos_configsCount(state) {
      return state.pos_configsCount
    },
    getPos_config(state) {
      return state.pos_config
    },
    getPos_config_pay3d(state) {
      return state.pos_config_pay3d
    },
    getPos_configSaveStatus(state) {
      return state.pos_configSave
    },
    getInstallments(state) {
      return state.pos_installments
    },
    getInstallmentsV2(state) {
      return state.pos_installmentsv2
    },
  },
  mutations: {
    POS_TYPES(state, data) {
      state.pos_types = data
    },
    POS_CONFIGS_LIST(state, data) {
      state.pos_configs = data
    },
    POS_CONFIG_RESET(state) {
      state.pos_config = defaultPosConfig()
      state.pos_configSave = {
        message: null,
        status: null,
        id: null,
      }
    },
    POS_CONFIG_FOR_TYPE(state, idPosTypes) {
      state.pos_config.config = emptyConfigForPosType(idPosTypes)
    },
    POS_CONFIG_VIEW(state, data) {
      const incoming = data || {}
      state.pos_config = {
        ...defaultPosConfig(),
        ...incoming,
        config: pickConfigForPosType(incoming.config, incoming.id_pos_types),
      }
    },
    POS_CONFIG_PAY3D(state, data) {
      state.pos_config_pay3d = data
    },
    POS_CONFIGS_COUNT(state, data) {
      state.pos_configsCount = data
    },
    POS_CONFIG_SAVE(state, data) {
      state.pos_configSave = data
    },
    POS_INSTALLMENTS(state, data) {
      state.pos_installments = data
    },
    POS_INSTALLMENTS_V2(state, data) {
      const bodyIn = (data && data.body) || []
      const counts = []
      bodyIn.forEach(item => {
        (item.installments || []).forEach(row => {
          if (!row || row.installment == null || row.installment === '') return
          const n = Number(row.installment)
          if (Number.isNaN(n)) return
          if (counts.indexOf(n) === -1) counts.push(n)
        })
      })
      counts.sort((a, b) => a - b)
      if (!counts.length) {
        state.pos_installmentsv2 = data || { header: [], body: [] }
        return
      }
      state.pos_installmentsv2 = {
        header: ['BANKA', ...counts.map(n => (n === 0 ? 'TEK ÇEKİM' : `${n} Taksit`))],
        body: bodyIn.map(item => {
          const byCount = {}
          ;(item.installments || []).forEach(row => {
            if (!row || row.installment == null || row.installment === '') return
            const n = Number(row.installment)
            if (Number.isNaN(n)) return
            byCount[n] = row
          })
          return {
            ...item,
            installments: counts.map(n => byCount[n] || { text: null, installment: null, rate: null }),
          }
        }),
      }
    },
  },
  actions: {
    pos_types({ commit }) {
      axiosIns
        .post('/pos_types')
        .then(response => {
          commit('POS_TYPES', response.data.data)
        })
        .catch(error => console.error(error))
    },
    pos_installments({ commit }) {
      axiosIns
        .post('/pos_configs/installments')
        .then(response => {
          commit('POS_INSTALLMENTS', response.data.data)
        })
        .catch(error => console.error(error))
    },
    pos_installments2({ commit }, payload = {}) {
      const idCustomers = payload.id_customers || null
      const parseRate = rate => parseFloat(String(rate == null ? 0 : rate).replace(',', '.')) || 0
      const normalizeInstallmentTable = data => {
        const bodyIn = (data && data.body) || []
        const counts = []
        bodyIn.forEach(item => {
          ;(item.installments || []).forEach(row => {
            if (!row || row.installment == null || row.installment === '') return
            const n = Number(row.installment)
            if (Number.isNaN(n)) return
            if (counts.indexOf(n) === -1) counts.push(n)
          })
        })
        counts.sort((a, b) => a - b)
        if (!counts.length) counts.push(0)
        const header = ['BANKA', ...counts.map(n => (n === 0 ? 'TEK ÇEKİM' : `${n} Taksit`))]
        const body = bodyIn.map(item => {
          const byCount = {}
          ;(item.installments || []).forEach(row => {
            if (!row || row.installment == null || row.installment === '') return
            const n = Number(row.installment)
            if (Number.isNaN(n)) return
            byCount[n] = {
              text: n === 0 ? 'Tek Çekim' : `${n} Taksit`,
              title: n === 0 ? 'Tek Çekim' : `${n} Taksit`,
              installment: n,
              rate: parseRate(row.rate),
            }
          })
          return {
            ...item,
            installments: counts.map(n => byCount[n] || { text: null, installment: null, rate: null }),
          }
        })
        return { header, body }
      }
      const hasOptions = data => {
        if (!data || !Array.isArray(data.body) || !data.body.length) return false
        return data.body.some(item => (item.installments || []).some(row => row && (row.text || row.title || row.installment === 0 || row.installment === '0')))
      }
      const mapCustomerInstallments = rows => {
        const list = Array.isArray(rows) ? rows : []
        const body = list.map(row => {
          const source = (row.privates && row.privates.length) ? row.privates : (row.defaults || [])
          return {
            id_pos_configs: row.id || row.id_pos_configs,
            id_banks: row.id_banks || null,
            title: row.title,
            installments: source.map(item => ({
              text: item.title || item.text,
              installment: item.installment == null ? 0 : item.installment,
              rate: parseRate(item.rate),
            })),
          }
        })
        return normalizeInstallmentTable({ body })
      }
      const mapFlatInstallments = rows => {
        const list = Array.isArray(rows) ? rows : []
        const grouped = {}
        list.forEach(item => {
          const posId = item.id_pos_configs
          if (!posId) return
          if (!grouped[posId]) {
            grouped[posId] = {
              id_pos_configs: posId,
              title: item.bank || item.pos_title || item.title,
              installments: [],
            }
          }
          grouped[posId].installments.push({
            text: item.title || item.text,
            installment: item.installment == null ? 0 : item.installment,
            rate: parseRate(item.rate),
          })
        })
        return normalizeInstallmentTable({ body: Object.keys(grouped).map(key => grouped[key]) })
      }

      return axiosIns
        .post('/pos_configs/installmentsv2', { id_customers: idCustomers })
        .then(response => {
          const data = response.data && response.data.data
          if (hasOptions(data)) {
            const normalized = normalizeInstallmentTable(data)
            commit('POS_INSTALLMENTS_V2', normalized)
            return normalized
          }
          return axiosIns
            .post('/pos_installments/customerInstallments', { id_customers: idCustomers })
            .then(customerRes => {
              const mapped = mapCustomerInstallments(customerRes.data && customerRes.data.data)
              if (hasOptions(mapped)) {
                commit('POS_INSTALLMENTS_V2', mapped)
                return mapped
              }
              return axiosIns
                .post('/pos_installments', {
                  select: [
                    'pos_installments.id AS id',
                    'pos_installments.title AS title',
                    'pos_installments.installment AS installment',
                    'pos_installments.rate AS rate',
                    'pos_installments.id_pos_configs AS id_pos_configs',
                    'banks.title AS bank',
                  ],
                  where: {
                    'pos_installments.is_private': '0',
                  },
                })
                .then(flatRes => {
                  const mappedFlat = mapFlatInstallments(flatRes.data && flatRes.data.data)
                  commit('POS_INSTALLMENTS_V2', mappedFlat)
                  return mappedFlat
                })
            })
        })
        .catch(error => console.error(error))
    },
    pos_configsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/pos_configs', data)
        .then(response => {
          commit('POS_CONFIGS_LIST', response.data.data)
          commit('POS_CONFIGS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    pos_configView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'pos_configs.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/pos_configs', data)
        .then(response => {
          const pos = response.data.data || {}
          return axiosIns
            .post('/pos_installments', {
              where: {
                'pos_installments.id_pos_configs': id,
                'pos_installments.is_private': '0',
              },
              order_by: ['pos_installments.installment', 'ASC'],
            })
            .then(instRes => {
              const rows = (instRes.data && instRes.data.data) || []
              if (Array.isArray(rows) && rows.length) {
                pos.installments = rows.map(row => ({
                  id: row.id,
                  text: row.title || row.text || 'Taksit',
                  title: row.title || row.text || 'Taksit',
                  installment: row.installment,
                  rate: row.rate,
                }))
              } else if (!Array.isArray(pos.installments) || !pos.installments.length) {
                pos.installments = [{ text: 'Tek Çekim', title: 'Tek Çekim', installment: 0, rate: 0 }]
              }
              commit('POS_CONFIG_VIEW', pos)
            })
            .catch(() => {
              commit('POS_CONFIG_VIEW', pos)
            })
        })
        .catch(error => console.error(error))
    },
    pos_configPay3d({ commit }, id) {
      const data = JSON.stringify({
        select: [
          'pos_configs.id AS id',
          'pos_configs.pay3d AS pay3d',
        ],
        where: {
          'pos_configs.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/pos_configs', data)
        .then(response => {
          commit('POS_CONFIG_PAY3D', response.data.data.pay3d)
        })
        .catch(error => console.error(error))
    },
    pos_configSave({ commit, dispatch }, postData) {
      const installments = (postData.installments || []).map(item => ({
        id: item.id || undefined,
        text: item.text || item.title || 'Taksit',
        title: item.title || item.text || 'Taksit',
        installment: parseInt(item.installment, 10) || 0,
        rate: parseFloat(String(item.rate == null ? 0 : item.rate).replace(',', '.')) || 0,
      }))
      const config = compactConfig(pickConfigForPosType(postData.config, postData.id_pos_types))
      const payload = {
        ...postData,
        default: postData.default ? 1 : 0,
        status: postData.status ? 1 : 0,
        pay3d: postData.pay3d ? 1 : 0,
        config,
        installments,
      }
      return axiosIns
        .post('/pos_configs/saveData', JSON.stringify(payload))
        .then(response => {
          commit('POS_CONFIG_SAVE', response.data)
          const posId = (response.data && response.data.id) || postData.id
          if (!posId) return response.data
          return dispatch('syncDefaultInstallments', {
            id_pos_configs: posId,
            installments,
          }).then(() => response.data)
        })
        .catch(error => console.error(error))
    },
    syncDefaultInstallments({ dispatch }, payload) {
      const posId = payload.id_pos_configs
      const installments = payload.installments || []
      return axiosIns
        .post('/pos_installments', {
          where: {
            'pos_installments.id_pos_configs': posId,
            'pos_installments.is_private': '0',
          },
        })
        .then(existingRes => {
          const existing = (existingRes.data && existingRes.data.data) || []
          const deletes = existing.map(row => axiosIns.post('/pos_installments/deleteData', {
            id: row.id,
          }))
          return Promise.all(deletes).then(() => {
            const saves = installments.map(item => axiosIns.post('/pos_installments/saveData', {
              title: item.text || item.title || 'Taksit',
              installment: parseInt(item.installment, 10) || 0,
              rate: parseFloat(String(item.rate == null ? 0 : item.rate).replace(',', '.')) || 0,
              is_private: 0,
              id_customers: null,
              id_pos_configs: posId,
            }))
            return Promise.all(saves)
          })
        })
        .catch(error => {
          console.error(error)
          return dispatch('pos_installments2')
        })
    },
  },
}
